import React from 'react'

class RedirectHandler extends waffle.base.BaseComponent {
  constructor(props) {
    super(props);
  }
  
  componentWillMount() {
    this.invokeCore();
  }
  
  invokeCore() {
    radio('showLoader').broadcast();
    $.ajax({
      url: this.props.url,
      method: 'GET'
    }).done((response) => {
      radio('hideLoader').broadcast();
      if (response.status === 303) {
        window.location = response.data.url;
      } else {
        radio('showAlert').broadcast('danger', `${response.message} (${response.status})`);
      }
    }).fail((_, textStatus) => {
      radio('hideLoader').broadcast();
      radio('showAlert').broadcast('danger', textStatus);
    });
  }
  
  render() {
    return <div/>;
  }
}

module.exports = {
  RedirectHandler
}
